/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import Search from "./Search";
import SaleRepSearch from "../SaleRepCapabilities/saleRepSearch";
import {Button} from '@pearson-components/elements-sdk/build/dist.elements-sdk';
import Collapsible from 'react-collapsible';
import CollectionSearchError from "./CollectionSearchError";
import LoadingIndicator from "../../widgets/LoadingIndicator/LoadingIndicator";
import Svg from "../../widgets/Svg/Svg";
import PrintCollections from "./PrintCollections";
import DigitalCollections from "./DigitalCollections";
import { Tabs, Pane } from "@pearson-components/elements-sdk/build/dist.elements-sdk";
import { formatUrl } from "../../../_helpers/urlFormat.helper";
import axiosClient from "../../../_helpers/http.helper";
import config from "../../../config";
import { asyncWrapper } from "../../../_helpers/async.helper";
import union from "lodash/union";
import Select from 'react-select';
import urlHelper from "../../../_helpers/url.format.helper";
import { AuthConsumer } from "../../context/AuthContext";
import { PERMISSIONS,SALESREP } from "../../../constants/APP_CONSTANTS";
import ShareModal from "../../widgets/shareModal/ShareComponent";

class HomePage extends React.Component {

    state = {
        isbn: "",
        instructor: "",
        title: "",
        school: "",
        shareModalData: {
            collection: "",
            isShareModelOpen: false
        },
        printCollection: {
            totalItems: 0,
            pageNumber: null,
            items: []
        },
        digitalCollection: {
            totalItems: 0,
            pageNumber: null,
            items: []
        },
        hasMorePrintCollections: true,
        hasMoreDigitalCollections: true,
        selectedTabIndex: 0,
        defaultValue: {
            value: '0',
            label: 'Actions'
        },
        dropdownOptions: [
            {
                value: "0",
                label: 'Actions'
            },
            {
                value: "1",
                label: "Move-To Test"
            }
        ],
        selected: [],
        selectAll: 0,
        selectAllDigital: 0,
        collectionIds: [],
        isPending: false,
        loading: false,
        isVisible: false
    };

    updateDigitalCollectionWithAdminStatusAndInviteDate = (adminStatus) => {
        this.setState(prevState => {
            let updatedCollection = prevState.digitalCollection.items.map(item => {
                return {
                    ...item,
                    inviteSent: item.inviteSent ? item.inviteSent : adminStatus[item.collection.collectionId] && adminStatus[item.collection.collectionId].inviteSent ? adminStatus[item.collection.collectionId].inviteSent : null,
                    collection : {
                        ...item.collection,
                        status : adminStatus[item.collection.collectionId] && item.productDeliveryType === "custometext" && adminStatus[item.collection.collectionId].adminStatus ? adminStatus[item.collection.collectionId].adminStatus : item.collection.status
                    }
                };
            });
            return {
                ...prevState,
                digitalCollection : {
                    ...prevState.digitalCollection,
                    items: updatedCollection
                }
            };
        });
    };

    updateVitalSourceWithAdminStatusAndInviteDate = (adminStatus) => {
        this.setState(prevState => {
            let updatedCollection = prevState.digitalCollection.items.map(item => {
                return {
                    ...item,
                    inviteSent: item.inviteSent ? item.inviteSent : adminStatus[item.collection.collectionId] && adminStatus[item.collection.collectionId].inviteSent ? adminStatus[item.collection.collectionId].inviteSent : null,
                    collection : {
                        ...item.collection,
                        status : adminStatus[item.collection.collectionId] && item.productDeliveryType === "vitalsource" && adminStatus[item.collection.collectionId].adminStatus ? adminStatus[item.collection.collectionId].adminStatus : item.collection.status
                    }
                };
            });
            return {
                ...prevState,
                digitalCollection : {
                    ...prevState.digitalCollection,
                    items: updatedCollection
                }
            };
        });
    };

    togglePrintRow = obj => {
        const newSelected = Object.assign({}, this.state.selected);
        newSelected[obj.collectionId] = !this.state.selected[
            obj.collectionId];
        this.setState({
            selected: newSelected,
            selectedTabIndex: 0
        });
    };

    togglePrintAll = () => {
        const newSelected = Object.assign({}, this.state.selected);
        this.state.printCollection.items.map(obj => {
            newSelected[obj.collection.collectionId] = !this.state.selectAll;
        });
        this.setState({
            selected: newSelected,
            selectAll: !this.state.selectAll,
            selectedTabIndex: 0
        });
    };

    toggleDigitalRow = obj => {
        const newSelected = Object.assign({}, this.state.selected);
        newSelected[obj.collectionId] = !this.state.selected[
            obj.collectionId];
        this.setState({
            selected: newSelected,
            selectedTabIndex: 1

        });
    };

    toggleDigitalAll = () => {
        const newSelected = Object.assign({}, this.state.selected);
        this.state.digitalCollection.items.map(obj => {
            newSelected[obj.collection.collectionId] = !this.state.selectAllDigital;
        });
        this.setState({
            selected: newSelected,
            selectAllDigital: !this.state.selectAllDigital,
            selectedTabIndex: 1
        });
    };

    resetResults = () => {
        this.setState({
            ...this.state,
            selectAll: 0,
            selectAllDigital: 0,
            selected: {},
            defaultValue: {
                value: '0',
                label: 'Actions'
            },
        });
    };

    updateProductDelivery = (index, type) =>{
        this.setState(prevState => {

            const newItems = prevState.digitalCollection.items.map((item, itemIndex) => {
                return (index === itemIndex) ? {
                    ...item,
                    productDeliveryType: type
                } : item;
            });
            return {
                ...prevState,
                selectedTabIndex: 1,
                digitalCollection:{
                    ...prevState.digitalCollection,
                    items: newItems
                }
            };
        });
    };

    searchPrintCollections = (parameters) => {
        let printSearchUrl = formatUrl(config.collectionService.baseUrl, config.collectionService.routes.collectionsSearch, {
            type: "print",
            queryParams: {
                pageSize: 11,
                pageNumber: this.state.printCollection.pageNumber === null
                    ? 0
                    : this.state.printCollection.pageNumber + 1
            }
        });

        let searchObject = {};
        Object.keys(parameters).map(item => {
            if (parameters[item] !== ""){
                searchObject[item] = parameters[item];
            }
        });
        return axiosClient.post(printSearchUrl, searchObject);
    };

    searchDigitalCollections = (parameters) => {
        let digitalSearchUrl = formatUrl(config.collectionService.baseUrl, config.collectionService.routes.collectionsSearch, {
            type: "digital",
            queryParams: {
                pageSize: 11,
                pageNumber: this.state.digitalCollection.pageNumber === null
                    ? 0
                    : this.state.digitalCollection.pageNumber + 1
            }
        });

        let searchObject = {};
        Object.keys(parameters).map(item => {
            if(parameters[item] !== ""){
                searchObject[item] = parameters[item];
            }
        });

        return axiosClient.post(digitalSearchUrl, searchObject);
    };

    setInitailState = async (parameters = {}) => {
        const {isbn='', instructor='', title ='', school = ''} = parameters;
        this.setState({
            loading: true,
            showSearchError: false,
            isbn: isbn,
            instructor:instructor,
            title: title,
            school: school,
            printCollection: {
                totalItems: 0,
                pageNumber: null,
                items: []
            },
            digitalCollection: {
                totalItems: 0,
                pageNumber: null,
                items: []
            },
            hasMorePrintCollections: true,
            hasMoreDigitalCollections: true
        });
    };

    search = async (parameters) => {
        this.resetResults();
        await this.setInitailState(parameters);
        const {error: printError, data: printCollections} = await asyncWrapper(this.searchPrintCollections(parameters));
        const {error: digitalError, data: digitalCollections} = await asyncWrapper(this.searchDigitalCollections(parameters));
        let collectionIds = [];

        if (printError || digitalError) {
            if(digitalError.response.data.errorCode == "CL009"){
                this.setState({
                    showSearchError: true
                });
            }
            this.setState({
                loading: false
            });
        } else {
            collectionIds = digitalCollections.data && digitalCollections.data.content.map(item => {
                return item.collection.collectionId;
            });
            this.setState(prevState => {
                return ({
                    printCollection: {
                        items: prevState.isPending ? printCollections.data.content : union([
                            ...prevState.printCollection.items,
                            ...printCollections.data.content
                        ], 'transactionId'),
                        pageNumber: printCollections.data.number,
                        totalItems: printCollections.data.totalElements,
                    },
                    digitalCollection: {
                        items: prevState.isPending ? digitalCollections.data.content : union([
                            ...prevState.digitalCollection.items,
                            ...digitalCollections.data.content
                        ], 'transactionId'),
                        pageNumber: digitalCollections.data.number,
                        totalItems: digitalCollections.data.totalElements,
                    },
                    loading: false,
                    showSearchError: false,
                    hasMorePrintCollections: !printCollections.data.last,
                    hasMoreDigitalCollections: !digitalCollections.data.last,
                    isPending: false,
                    selectedTabIndex : printCollections.data.content.length == 0 && digitalCollections.data.content.length >0 ? 1: 0
                });
            },() => {
                this.getCollectionAdminStatus(collectionIds).then((response)=>{
                    this.updateDigitalCollectionWithAdminStatusAndInviteDate(response.data);
                });
                this.getVitalSourceAdminStatus(collectionIds).then((response)=>{
                    this.updateVitalSourceWithAdminStatusAndInviteDate(response.data);
                });
            },
            );
        }
    };

    moveCollectionsToTest() {

        let selectedIds = [];
        let keys = Object.keys(this.state.selected);
        keys.map(collectionId => {
            if(this.state.selected[collectionId]===true){
                selectedIds.push(collectionId);
            }
        });

        if(selectedIds.length > 0 ){
            const updateUrl = urlHelper.formatUrl(
                config.collectionService.baseUrl,
                config.collectionService.routes.moveTo
            );

            axiosClient.post(updateUrl, selectedIds, { "headers": { "content-type": "application/json" } })
                .then(response => {
                    asyncWrapper(this.search({
                        isbn: this.state.isbn,
                        instructor: this.state.instructor,
                        title: this.state.title,
                        school: this.state.school
                    }));
                    return response.data;
                }).catch((error) => {
                    console.log("Error", error);
                });
        }

    }

    loadMorePrintCollections = async () => {
        if (!this.state.hasMorePrintCollections) {
            return;
        }
        const {error: printError, data: printCollections} = await asyncWrapper(this.searchPrintCollections({
            isbn: this.state.isbn,
            instructor: this.state.instructor,
            title: this.state.title,
            school: this.state.school
        }));

        if (printCollections) {
            this.setState(prevState => ({
                printCollection: {
                    items: union([
                        ...prevState.printCollection.items,
                        ...printCollections.data.content
                    ], 'transactionId'),
                    pageNumber: printCollections.data.number,
                    totalItems: printCollections.data.totalElements,
                    loading: false
                },
                selectedTabIndex: 0,
                hasMorePrintCollections: !printCollections.data.last,
            }));
        }
    };

    loadMoreDigitalCollections = async () => {
        if (!this.state.hasMoreDigitalCollections) {
            return;
        }

        const {error: digitalError, data: digitalCollections} = await asyncWrapper(this.searchDigitalCollections({
            isbn: this.state.isbn,
            instructor: this.state.instructor,
            title: this.state.title,
            school: this.state.school
        }));

        if (digitalCollections) {
            let collectionIds = digitalCollections.data.content.map(item => {
                return item.collection.collectionId;
            });

            this.setState(prevState => {
                return ({
                    digitalCollection: {
                        items: union([
                            ...prevState.digitalCollection.items,
                            ...digitalCollections.data.content
                        ], 'transactionId'),
                        pageNumber: digitalCollections.data.number,
                        totalItems: digitalCollections.data.totalElements,
                        loading: false
                    },
                    selectedTabIndex: 1,
                    hasMoreDigitalCollections: !digitalCollections.data.last
                });
            },() => {
                this.getCollectionAdminStatus(collectionIds).then((response)=>{
                    this.updateDigitalCollectionWithAdminStatusAndInviteDate(response.data);
                });
                this.getVitalSourceAdminStatus(collectionIds).then((response)=>{
                    this.updateVitalSourceWithAdminStatusAndInviteDate(response.data);
                });
            },

            );
        }
    };

    getCollectionAdminStatus = (collectionsIdList) => {
        let url = formatUrl(config.contentPublishService.baseUrl, config.contentPublishService.routes.getAdminStatus);
        return axiosClient.post(url, collectionsIdList);
    };

    getVitalSourceAdminStatus = (collectionsIdList) => {
        let url = formatUrl(config.contentPublishVitalsourceService.baseUrl, config.contentPublishVitalsourceService.routes.getVitalSourceAdminStatus);
        return axiosClient.post(url, collectionsIdList);
    };

    clearFields = (parameters) => {
        const userRolePermissions = this.props.permissions;
        this.setState({
            isbn: parameters.isbn,
            instructor: parameters.instructor,
            title: parameters.title,
            school: parameters.school,
            selectedTabIndex: 0
        });

        if (!this.state.isPending && !userRolePermissions.includes(PERMISSIONS.hide_only_pending_collections_button)) {
            this.loadPendingCollections();
        }
    };

    onChange(e){
        this.setState({defaultValue: {value: e.value, label: e.label}});

        if (Number(e.value) === 1 ){
            this.moveCollectionsToTest(this.state.selected);
        }
    }

    updateShareModalData = (collection, isShareModelOpen) => {
        this.setState(prevState => ({ ...prevState, selectedTabIndex: collection.collectionType === 'Digital' ? 1 : 0,shareModalData: { collection: collection, isShareModelOpen : isShareModelOpen }}));
    }

    closeShareCollectionModal = () => {
        this.setState({shareModalData: {isShareModelOpen : false}});
    }

    shareCollection = ({collectionId, emails, newCount, userIds, message}) => {
        this.setState({shareModalData: {isShareModelOpen : false}});
        const shareCollectionPromises = [];
        if(userIds && userIds.length > 0){
            shareCollectionPromises.push(axiosClient.post(formatUrl(config.collectionService.baseUrl, config.collectionService.routes.shareCollection, {collectionId, userId : this.props.userProfile.id}), {userIds, message}));
        }
        if(emails && emails.length > 0){
            shareCollectionPromises.push(axiosClient.post(formatUrl(config.collectionService.baseUrl, config.collectionService.routes.shareCollectionByEmail, {collectionId, userId : this.props.userProfile.id }), {userIds: emails, message}));
        }
        return Promise.all(shareCollectionPromises);
    }

    async componentDidMount() {
        const userRolePermissions = this.props.permissions;
        if (!userRolePermissions.includes(PERMISSIONS.hide_only_pending_collections_button)) {
            this.setState({
                loading: true
            });
            const {error: printError, data: printCollections} = await asyncWrapper(this.getPendingCollections('print'));
            const {error: digitalError, data: digitalCollections} = await asyncWrapper(this.getPendingCollections('digital'));
            if (printError || digitalError) {
                if (digitalError.response.data.errorCode == "CL009") {
                    this.setState({
                        showSearchError: true
                    });
                }
                this.setState({
                    loading: false
                });
            } else {
                this.pendingCollectionStateupdate(printCollections, digitalCollections);
            }
        }

        if (userRolePermissions.includes(PERMISSIONS.view_only_instructor_navigation_button)) {
            this.loadInstructorNavigationOption();
        }  
    }

    pendingCollectionStateupdate(printCollections, digitalCollections) {
        let collectionIds = digitalCollections.data && digitalCollections.data.content.map(item => {
            return item.collection.collectionId;
        });
        this.setState({
            printCollection: {
                items: printCollections.data.content,
                pageNumber: printCollections.data.number,
                totalItems: printCollections.data.totalElements,
            },
            digitalCollection: {
                items: digitalCollections.data.content,
                pageNumber: digitalCollections.data.number,
                totalItems: digitalCollections.data.totalElements,
            },
            loading: false,
            showSearchError: false,
            hasMorePrintCollections: !printCollections.data.last,
            hasMoreDigitalCollections: !digitalCollections.data.last,
            isPending: true,
            selectedTabIndex : printCollections.data.content.length == 0 && digitalCollections.data.content.length >0 ? 1: 0
        }, () => {
            this.getCollectionAdminStatus(collectionIds).then((response) => {
                this.updateDigitalCollectionWithAdminStatusAndInviteDate(response.data);
            });
            this.getVitalSourceAdminStatus(collectionIds).then((response) => {
                this.updateVitalSourceWithAdminStatusAndInviteDate(response.data);
            });
        });
    }

    loadPendingCollections = async () => {
        await this.setInitailState();
        const {error: printError, data: printCollections} = await asyncWrapper(this.getPendingCollections('print'));
        const {error: digitalError, data: digitalCollections} = await asyncWrapper(this.getPendingCollections('digital'));
        if (printError || digitalError) {
            if (digitalError.response.data.errorCode == "CL009") {
                this.setState({
                    showSearchError: true
                });
            }
            this.setState({
                loading: false
            });
        } else {
            this.pendingCollectionStateupdate(printCollections, digitalCollections);
        }
    }

    getPendingCollections(type, pageNumber = 0) {
        let url = formatUrl(config.collectionService.baseUrl, config.collectionService.routes.pendingCollection, {
            type,
            queryParams: {
                pageNumber,
                pageSize: 10,
                status: 'pending'
            }
        });
        return axiosClient.get(url);
    }
    loadMorePendingPrintCollections = async () => {
        if (!this.state.hasMorePrintCollections) {
            return;
        }
        let pageNumber = this.state.printCollection.pageNumber === null ? 0 : this.state.printCollection.pageNumber + 1;
        const {error: printError, data: printCollections} = await asyncWrapper(this.getPendingCollections('print', pageNumber));
        if (printCollections) {
            this.setState(prevState => ({
                printCollection: {
                    items: union([
                        ...prevState.printCollection.items,
                        ...printCollections.data.content
                    ], 'transactionId'),
                    pageNumber: printCollections.data.number,
                    totalItems: printCollections.data.totalElements,
                    loading: false
                },
                selectedTabIndex: 0,
                hasMorePrintCollections: !printCollections.data.last,
            }));
        }
    };

    loadMorePendingDigitalCollections = async () => {
        if (!this.state.hasMoreDigitalCollections) {
            return;
        }
        let pageNumber = this.state.digitalCollection.pageNumber === null ? 0 : this.state.digitalCollection.pageNumber + 1;
        const {error: digitalError, data: digitalCollections} = await asyncWrapper(this.getPendingCollections('digital', pageNumber));
        if (digitalCollections) {
            let collectionIds = digitalCollections.data && digitalCollections.data.content.map(item => {
                return item.collection.collectionId;
            });
            this.setState(prevState => {
                return ({
                    digitalCollection: {
                        items: union([
                            ...prevState.digitalCollection.items,
                            ...digitalCollections.data.content
                        ], 'transactionId'),
                        pageNumber: digitalCollections.data.number,
                        totalItems: digitalCollections.data.totalElements,
                        loading: false
                    },
                    selectedTabIndex: 1,
                    hasMoreDigitalCollections: !digitalCollections.data.last
                });
            }, () => {
                this.getCollectionAdminStatus(collectionIds).then((response) => {
                    this.updateDigitalCollectionWithAdminStatusAndInviteDate(response.data);
                });
                this.getVitalSourceAdminStatus(collectionIds).then((response) => {
                    this.updateVitalSourceWithAdminStatusAndInviteDate(response.data);
                });
            });
        }
    };

    getShareModal = () => {
        const { userProfile } = this.props;
        return (
            <ShareModal collection={this.state.shareModalData.collection}
                close={this.closeShareCollectionModal}
                collectionId={this.state.shareModalData.collection.collectionId}
                collectionTitle={this.state.shareModalData.collection.title}
                isOpen={this.state.shareModalData.isShareModelOpen}
                shareCollection={(params) => this.shareCollection(params)}
                user = {userProfile}/>
        );
    }

    loadInstructorNavigationOption = () => {
        let checkHeaderExist = setInterval(() => {
            if (document.querySelector(".o-app-header__nav-item-help")) {
                document.querySelector(".o-app-header__nav-item-help").insertAdjacentHTML('beforebegin', '<li class="o-header__nav-item o-app-header__nav-item-navigation"> <a href=' + window.location.origin + ' target="_blank"> <button class="instructor-navigation-btn" > Instructor Portal </button></a > </li>');
                clearInterval(checkHeaderExist);
            }
        }, 100);
    }
    render() {
        const userRolePermissions = this.props.permissions;
        const { permissions } = this.props;

        return (
            <div>
                {!userRolePermissions.includes(PERMISSIONS.view_only_salesrep_search_page) ? <div className="home-page">
                    {this.state.shareModalData.collection && this.state.shareModalData.collection.collectionId && this.getShareModal()}
                    <Search search={this.search}
                        isLoading={this.state.loading }
                        clearFields={this.clearFields}
                        isPending={this.state.isPending}
                        loadPending={this.loadPendingCollections}
                        permissions = {permissions}/>

                    {this.state.printCollection.pageNumber !== null || this.state.digitalCollection.pageNumber !== null ?
                        <div className="search-summary">
                            {this.state.isPending ?
                                (<h6 style={{ marginRight: "5px" }}>Pending Collections : </h6>)
                                :
                                <h6 style={{ marginRight: "5px" }}>Search Results for :
                                    {this.state.isbn ? "Isbn = " + this.state.isbn + "; " : ""}
                                    {this.state.instructor ? "Instructor = " + this.state.instructor + "; " : ""}
                                    {this.state.title ? "Title = " + this.state.title + "; " : ""}
                                    {this.state.school ? "School = " + this.state.school + "; " : ""}
                                </h6>
                            }
                            <h6 className="collection-count">
                                {this.state.printCollection.totalItems ? this.state.printCollection.totalItems + " Print results " : "0 Print results"}
                                {this.state.digitalCollection.totalItems ? "|" + this.state.digitalCollection.totalItems + " Digital results " : " | 0 Digital results"}

                            </h6>
                            { !userRolePermissions.includes(PERMISSIONS.hide_only_actions_tab) ? <div className="options-dropdown">
                                <Select arrowRenderer={this.props.arrowRenderer || this.arrowDown}
                                    id="select_dropdown"
                                    backspaceRemoves={false}
                                    clearable={false}
                                    name={this.state.defaultValue.label}
                                    value={this.state.defaultValue.value}
                                    onChange={(e) => this.onChange(e)}
                                    options={this.state.dropdownOptions}
                                    searchable={false}
                                />
                            </div> : ""}
                            <hr/>
                        </div> : ""}
                    { (this.state.loading === true && userRolePermissions.includes(PERMISSIONS.hide_only_loaderIndicator )) ? <LoadingIndicator/> : <React.Fragment>
                        {this.state.printCollection.pageNumber !== null || this.state.digitalCollection.pageNumber !== null ?
                            <Tabs selected={this.state.selectedTabIndex}>
                                <Pane label={"Print Collections"}>
                                    {this.state.printCollection.totalItems > 0  ?<PrintCollections
                                        selectAll={this.state.selectAll}
                                        togglePrintRow={this.togglePrintRow}
                                        togglePrintAll={this.togglePrintAll}
                                        updateShareModalData={this.updateShareModalData}
                                        selectedData={this.state.selected}
                                        collections={this.state.printCollection}
                                        hasMore={this.state.hasMorePrintCollections}
                                        isPending={this.state.isPending}
                                        loadMore={this.state.isPending?this.loadMorePendingPrintCollections:this.loadMorePrintCollections}/> : <div className="no-collection-lable">No Print Collections</div>}
                                </Pane>
                                <Pane label={"Digital Collections"}>
                                    {this.state.digitalCollection.totalItems > 0  ? <DigitalCollections
                                        selectAllDigital={this.state.selectAllDigital}
                                        toggleDigitalRow={this.toggleDigitalRow}
                                        toggleDigitalAll={this.toggleDigitalAll}
                                        updateShareModalData={this.updateShareModalData}
                                        selectedData={this.state.selected}
                                        updateProductDelivery={this.updateProductDelivery}
                                        collections={this.state.digitalCollection}
                                        hasMore={this.state.hasMoreDigitalCollections}
                                        loadMore={this.state.isPending?this.loadMorePendingDigitalCollections:this.loadMoreDigitalCollections}
                                        permissions = {permissions}
                                        updateDigitalCollection={this.updateDigitalCollectionWithAdminStatus}/> : <div className="no-collection-lable">No Digital Collections</div>}
                                </Pane>
                            </Tabs> : ""}

                        {this.state.showSearchError === true ? <CollectionSearchError/> : ""}
                    </React.Fragment> }
                </div> : <div className="search-header">
                    <label className="pe-page-title--small">
                        Sales Representative Home Page
                    </label>
                    <hr/>
                    <div>Welcome to the Collections Admin Portal</div><br></br>
                    <div className={this.state.isVisible ? 'is-visible' : null}>
                        <div className="course-box">
                            <Collapsible
                                trigger={
                                    <div className="course-header"><span
                                        role="button"
                                        aria-expanded={this.state.isVisible}
                                    > {SALESREP.SEARCH_ANY_COLLECTION} </span></div>
                                }
                                overflowWhenOpen="visible"
                                tabIndex={0}
                                triggerSibling={() => <span><Svg svgString="bi-chevron-down" /></span>}
                                onOpening={() => this.setState({ isVisible: true })}
                                onClose={() => this.setState({ isVisible: false })}
                            >
                                <div><span className="details-span"> {SALESREP.CLICK}{<span className="bold-text">{SALESREP.SALESREP_SEARCH}</span>}{SALESREP.FIND_COLLECTION} </span></div>
                            </Collapsible>
                        </div>
                        <div className="course-box">
                            <Collapsible
                                trigger={
                                    <div className="course-header"><span
                                        role="button"
                                        aria-expanded={this.state.isVisible}
                                    > {SALESREP.VIEW_ONLY_MODE_FOR_ANY_COLLECTION} </span></div>
                                }
                                overflowWhenOpen="visible"
                                tabIndex={0}
                                triggerSibling={() => <span><Svg svgString="bi-chevron-down" /></span>}
                                onOpening={() => this.setState({ isVisible: true })}
                                onClose={() => this.setState({ isVisible: false })}
                            >
                                <div>
                                    <span className="details-span"> {SALESREP.TO_VIEW_A_COLLECTION} </span>
                                    <span className="details-span"> {SALESREP.SEARCH_FOR_IT_A_LIST_OF_COLLECTIONS_APPEAR} </span>
                                    <span className="details-span">{SALESREP.CLICK_THE_TITLE_COLLECTION_YOU_WANT_TO_EXAMIN} </span>
                                </div>
                            </Collapsible>
                        </div>
                        <div className="course-box">
                            <Collapsible
                                trigger={
                                    <div className="course-header"><span
                                        role="button"
                                        aria-expanded={this.state.isVisible}
                                    > {SALESREP.SEE_COLLECTION_INSTITUTION}</span></div>
                                }
                                overflowWhenOpen="visible" 
                                tabIndex={0}
                                triggerSibling={() => <span><Svg svgString="bi-chevron-down" /></span>}
                                onOpening={() => this.setState({ isVisible: true })}
                                onClose={() => this.setState({ isVisible: false })}
                            >
                                <div>
                                    <span className="details-span"> {SALESREP.CLICK_SALESREP_SEARCH}{<span className="bold-text">{SALESREP.SALESREP_SEARCH}</span>}</span>
                                    <span className="details-span"> {SALESREP.ENTER_NAME_INSTITUTION_SEE}</span>
                                    <span className="details-span"> {SALESREP.CLICKS}{<span className="bold-text">{SALESREP.CLICK_SEARCH}</span>}</span>
                                </div>
                            </Collapsible>
                        </div>
                        <div className="course-box" >
                            <Collapsible
                                trigger={
                                    <div className="course-header"> <span
                                        role="button"
                                        aria-expanded={this.state.isVisible}
                                    >{SALESREP.SEE_COLLECTION_CREATED}</span></div>
                                }
                                overflowWhenOpen="visible"
                                tabIndex={0}
                                triggerSibling={() => <span><Svg svgString="bi-chevron-down" /></span>}
                                onOpening={() => this.setState({ isVisible: true })}
                                onClose={() => this.setState({ isVisible: false })}
                            >
                                <div><span className="details-span"> {SALESREP.CLICK}{<span className="bold-text">{SALESREP.COLLECTION_LIST}</span>}{SALESREP.COLLECTION_CREATED} </span> </div>
                            </Collapsible>
                        </div>
                        <div className="course-box">
                            <Collapsible
                                trigger={
                                    <div className="course-header"><span
                                        role="button"
                                        aria-expanded={this.state.isVisible}
                                    >{SALESREP.CHANGE_COURSE_DATE} </span></div>
                                }
                                overflowWhenOpen="visible"
                                tabIndex={0}
                                triggerSibling={() => <span><Svg svgString="bi-chevron-down" /></span>}
                                onOpening={() => this.setState({ isVisible: true })}
                                onClose={() => this.setState({ isVisible: false })}
                            >
                                <div>
                                    <span className="details-span"> {SALESREP.CHANGE_COURSE_ASSOCIATED_DIGITAL_COLLECTION} </span>
                                    <span className="details-span"> {SALESREP.SEARCH_LIST_COLLECTION_APPEAR} </span>
                                    <span className="details-span"> {SALESREP.CLICK_TITLE_COLLECTION_MODIFY}</span>
                                    <span className="details-span"> {SALESREP.SELECT}{<span className="bold-text">{SALESREP.COURSE}</span>} {SALESREP.COURSE_DETAILS}</span>
                                    <span className="details-span">{SALESREP.SELECT_THE}{<span className="bold-text">{SALESREP.EDIT_COURSE_END_DATE}</span>}{SALESREP.FIELD_ENTER} </span>
                                </div>
                            </Collapsible>
                        </div>
                        <div className="course-box">
                            <Collapsible
                                trigger={
                                    <div className="course-header"><span
                                        role="button"
                                        aria-expanded={this.state.isVisible}> {SALESREP.ADD_INSTRUCTOR}</span></div>
                                }
                                overflowWhenOpen="visible"
                                tabIndex={0}
                                triggerSibling={() => <span><Svg svgString="bi-chevron-down" /></span>}
                                onOpening={() => this.setState({ isVisible: true })}
                                onClose={() => this.setState({ isVisible: false })}
                            >
                                <div>
                                    <span className="details-span">{SALESREP.ADD_INSTRUCTORS_COURSE_DIGITAL_COLLECTION} </span>
                                    <span className="details-span"> {SALESREP.SEARCH_LIST_COLLECTION} </span>
                                    <span className="details-span">{SALESREP.CLICK_COLLECTION_MODIFY} </span>
                                    <span className="details-span">{SALESREP.SELECT}{<span className="bold-text">{SALESREP.COURSE}</span>}.</span>
                                    <span className="details-span"> {SALESREP.SELECT_THE}{<span className="bold-text">{SALESREP.INSTRUCTOR_NAME}</span>}{SALESREP.ENTER_NAME_INSTRUCTOR}</span>
                                </div>
                            </Collapsible>
                        </div>
                    </div>
                </div> }
            </div>
        );
    }
}

const HomePageWithContext = (props) => (
    <AuthConsumer>
        {({userProfile}) => <HomePage {...props} userProfile={userProfile} permissions={Array.isArray(userProfile.permissions)?userProfile.permissions:[]} />}
    </AuthConsumer>
);

export default HomePageWithContext;



// WEBPACK FOOTER //
// ./src/components/pages/HomePage/HomePage.js